module.exports = "/assets/data/357e8f1e6478082156f84ebbaaf1b7a1-BA15.data.json";